/**
 * auth middleware — 在 ctx.headers 注入 `Authorization: Bearer <access>`。
 *
 * 设计要点：
 *  - access_token 存 `sessionStorage('fp_access')`；这与原 client.ts 行为一致。
 *  - 永远不把 token 写入 ctx.body，也不参与序列化。
 *  - 如果没有 access_token，跳过注入，让后端回 401，由 refresh middleware 接管。
 *  - 这是中间件链最外层（最先执行），保证 refresh middleware 重放请求时
 *    也能拿到新 token（refresh 自己负责写 setTokens）。
 */

import { ACCESS_TOKEN_KEY } from '../tokens';
import type { Middleware } from './types';

export const authMiddleware: Middleware = async (ctx, next) => {
  if (typeof sessionStorage !== 'undefined') {
    const access = sessionStorage.getItem(ACCESS_TOKEN_KEY);
    if (access && !ctx.headers['Authorization']) {
      ctx.headers['Authorization'] = `Bearer ${access}`;
    }
  }
  return next();
};
